import { Keys } from '../constants';
import { getStorageKeyName, widgetMetricPage, widgetMetricSessionGuid } from '../utils';
import { isMobile } from '../../../../UI/src/Helpers';
import { ModuleShortCodes } from '../../../../../container/src/constants';

const shortenModuleNames = longName => {
    return ModuleShortCodes[longName] || '??';
};

const registerSession = async (apiUrl, sessionData, companyId, modules, token, widgetConfiguration) => {
    const now = Math.round(new Date().getTime() / 1000);
    const sessionStart = parseInt(localStorage[getStorageKeyName(Keys.SESSION_START, companyId)], 10);

    // Only check for expired sessions when starting a new one. We do not want to kill the session_key
    // unless we can immediately make a new one.
    const sessionAge = now - (isNaN(sessionStart) ? 0 : sessionStart);
    const sessionGuid = sessionAge > Keys.SESSION_AGE_LIMIT ? null : widgetMetricSessionGuid(companyId);

    // We need a new session.
    if (sessionGuid) {
        return;
    }

    sessionData.module_type = modules.map(module => {
        return module.name;
    });
    sessionData.host_uri = widgetMetricPage();

    const mobileDevice = isMobile();

    const spotlightCount =
        modules.find(module => {
            return module.name === 'MODULE_CONCESSIONMANAGER' && !!module.app_data?.offer_ids;
        })?.app_data?.offer_ids?.length || 0;

    const apps_displayed = modules.map(module => {
        return shortenModuleNames(module.name);
    });

    // Notification Banner does not show up in the widget order list
    if (widgetConfiguration.widget_notification_bar_active) {
        apps_displayed.push(ModuleShortCodes.MODULE_NOTIFICATIONBANNER);
    }

    sessionData.sessionConfig = {
        apps_displayed,
        spotlight_count: spotlightCount,
        app_location: mobileDevice ? widgetConfiguration.widget_position_mobile : widgetConfiguration.widget_position,
        animation_style:
            widgetConfiguration.widget_skin === 'default' ? widgetConfiguration.widget_animation_style : '',
        widget_size: widgetConfiguration.widget_skin === 'default' ? widgetConfiguration.widget_size || 'large' : '',
        widget_skin: widgetConfiguration.widget_skin === 'default' ? 'default' : 'wallet',
        widgetbar_expanded: widgetConfiguration.widgetbar_expanded,
        build_time: process.env.BUILD_TIME
    };

    // We need a new session guid. Grab one now.
    const options = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(sessionData)
    };

    const request = await fetch(`${apiUrl}/widget_metrics`, options);
    const { session_guid } = await request.json();

    localStorage.setItem(getStorageKeyName(Keys.SESSION_START, companyId), `${now}`);
    localStorage.setItem(getStorageKeyName(Keys.SESSION_KEY, companyId), session_guid);
};

const recordEvent = (apiUrl, token, payload) => {
    const { moduleType, eventType, companyId, leadId, data } = payload;
    const sessionGuid = widgetMetricSessionGuid(companyId);

    if (!sessionGuid) {
        return;
    }

    const options = {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            event_type: eventType,
            module_type: moduleType,
            lead_id: leadId,
            host_uri: widgetMetricPage(),
            data
        })
    };

    fetch(`${apiUrl}/widget_metrics/${sessionGuid}/event`, options);
};

export default { recordEvent, registerSession };
